<template>
  <div class="scroll-container">
    <div class="scroll-content">
      <div class="scroll-item" v-for="(item, index) in list" :key="index">{{ item }}</div>
      <div class="scroll-item" v-for="(item, index) in list" :key="`a${index}`">{{ item }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MarqueeRoll",
  data() {
    return {
      list: [
        "177 **** 8083 0.1元领取会员",
        "135 **** 1212 0.1元领取会员",
        "139 **** 5656 0.1元领取会员",
        "181 **** 9625 0.1元领取会员",
        "192 **** 3121 0.1元领取会员",
        "136 **** 7511 0.1元领取会员",
      ]
    }
  }
}
</script>

<style scoped>
.scroll-container {
  width: 100%;
  height: 22px;
  overflow: hidden;
  position: relative;
}

.scroll-content {
  display: inline-block;
  white-space: nowrap;
  animation: scroll 15s linear infinite;
}

.scroll-item {
  width: 167px;
  height: 22px;
  line-height: 22px;
  font-size: 11px;
  color: #E2E2E2;
  background: #1B1B1B;
  border-radius: 11px;
  opacity: 0.54;
  display: inline-block;
  text-align: center;
  margin-right: 10px;
}

@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
</style>